import { render, staticRenderFns } from "./TranslateManyContentButton.vue?vue&type=template&id=22629a0c&scoped=true&"
import script from "./TranslateManyContentButton.vue?vue&type=script&lang=js&"
export * from "./TranslateManyContentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22629a0c",
  null
  
)

export default component.exports